module.exports = __webpack_public_path__ + "img/icon-campanha-pausada.6314e078.svg";